import jwtDecode from 'jwt-decode';
import { generateUserAgentHeader, getTermsOfUseId, getUserResourcePath, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { persistAuthSession } from 'Utilities/session';
export const signIn = ({
  email,
  password,
  osType,
  osVersion,
  app,
  appVersion,
  deviceId,
  installationId,
  appHash,
  force = false
}) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      name: 'login',
      method: 'POST',
      url: urls.apiUrl + 'v1/login',
      headers: {
        'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
        'X-Device-ID': deviceId,
        'X-Installation-ID': installationId,
        'X-Integrity-Token': appHash,
        'X-Bundle-ID': app
      },
      params: {
        force
      },
      data: {
        email,
        password,
        consents: [{
          id: getTermsOfUseId(app),
          action: 'accept'
        }, {
          id: 'pp',
          action: 'accept'
        }]
      }
    }).then(result => {
      if (result.data) {
        const decodedToken = jwtDecode(result.data.access_token);
        const authSession = {
          ...result.data,
          account_id: decodedToken.id,
          expires: decodedToken.exp
        };
        persistAuthSession({
          access_token: authSession.access_token,
          account_id: authSession.account_id,
          expires: authSession.expires
        });
        return resolve(authSession);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const forgotPass = (email, osType, osVersion, app, appVersion) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.apiUrl + 'v1/password/forgot',
      headers: {
        'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion)
      },
      data: {
        email
      }
    }).then(result => {
      resolve(result.data);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const resetPass = (password, tokenID, product, version) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.apiUrl + 'v1/password/reset',
      headers: {
        'X-User-Agent': generateUserAgentHeader(product, version)
      },
      data: {
        password,
        tokenID
      }
    }).then(result => {
      resolve(result.data);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const verifyEmail = (tokenID, osType, osVersion, app, appVersion) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'PUT',
      url: urls.apiUrl + 'v1/verifications/email',
      headers: {
        'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion)
      },
      data: {
        tokenID
      }
    }).then(result => {
      resolve(result.data);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const checkEmailVerification = ({
  account_id,
  osType,
  osVersion,
  app,
  appVersion,
  installationId
}) => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.apiUrl + `v1/${getUserResourcePath(app)}/${account_id}/verifications/email`,
      headers: {
        'X-User-Agent': generateUserAgentHeader(app, appVersion, osType, osVersion),
        'X-Installation-ID': installationId
      }
    }).then(result => {
      if (result.data) {
        const decodedToken = jwtDecode(result.data.access_token);
        const authSession = {
          ...result.data,
          account_id: decodedToken.id,
          expires: decodedToken.exp
        };
        persistAuthSession({
          access_token: authSession.access_token,
          account_id: authSession.account_id,
          expires: authSession.expires
        });
        return resolve(authSession);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};